export default __webpack_public_path__ + "static/team-c9f4a2d136f0bcb41981dde23fec5ac7.webp";